import React from 'react'
import PropTypes from 'prop-types'
import { Grid, GridItem } from '../grid'
import DetailsItem from '../details-item'
import HorizontalRule from '../horizontal-rule'
import Spacer from '../spacer'
import { formatDiamondShape } from '../../utils/format-labels'
import {
  displayDashIfNotExist,
  formatGradingReport,
  formatRatio,
  formatOrigin,
  formatDepth,
  formatTable,
  formatCrown,
  formatPavilion,
  formatSeparable,
  formatFancyIntensity,
  formatType,
  displayDecimal
} from '../../utils/format-diamond'

const DiamondDetails = props => {
  const { data } = props

  return (
    <div>
      <Spacer xs />
      <Grid>
        <GridItem col='1/4'>
          <DetailsItem title='Shape' value={formatDiamondShape(data['Shape'])} />
          <DetailsItem title='Cut' value={displayDashIfNotExist(data['Cut'])} />
          <DetailsItem title='Depth' value={formatDepth(data['Depth'])} />
          <DetailsItem title='Length/Width' value={formatRatio(data['Ratio'])} />
          <DetailsItem title='Origin' value={formatOrigin(data['Country of Origin'])} />
          <DetailsItem title='Grading Report' value={formatGradingReport(data['Lab'], data['Certificate Number'])} href={data['Certificate URL']} />
          <DetailsItem title='Seller' value={displayDashIfNotExist(data['Name Code Secret'])} />
          {data['Fancy Color'] && <DetailsItem title='Type' value={formatType(data['lg'])} />}
        </GridItem>
        <GridItem col='1/4'>
          <DetailsItem title='Carat' value={displayDecimal(data['Weight'])} />
          <DetailsItem title='Polish' value={displayDashIfNotExist(data['Polish'])} />
          <DetailsItem title='Table' value={formatTable(data['Table'])} />
          <DetailsItem title='Measurements' value={displayDashIfNotExist(data['Measurements'])} />
          <DetailsItem title='Shade' value={displayDashIfNotExist(data['Shade'])} />
          <DetailsItem title='Location' value={displayDashIfNotExist(data['Country'])} />
          {data['Fancy Color'] && <DetailsItem title='Intensity' value={formatFancyIntensity(data['Fancy Intensity'])} />}
          {!data['Fancy Color'] && <DetailsItem title='Type' value={formatType(data['lg'])} />}
        </GridItem>
        <GridItem col='1/4'>
          <DetailsItem title='Colour' value={data['Color'] || data['Fancy Color']} />
          <DetailsItem title='Symmetry' value={displayDashIfNotExist(data['Symmetry'])} />
          <DetailsItem title='Crown' value={formatCrown(data['Crown'], data['Crown Angle'], data['Crown Height'])} />
          <DetailsItem title='Girdle' value={displayDashIfNotExist(data['Girdle'])} />
          <DetailsItem title='Treatment' value={displayDashIfNotExist(data['Treatment'])} />
          <DetailsItem title='Match' value={displayDashIfNotExist(data['Pair Stock Number'])} />
          {data['Fancy Color'] && <DetailsItem title='Overtone' value={displayDashIfNotExist(data['Fancy color overtones'])} />}
        </GridItem>
        <GridItem col='1/4'>
          <DetailsItem title='Clarity' value={displayDashIfNotExist(data['Clarity'])} />
          <DetailsItem title='Fluorescence' value={displayDashIfNotExist(data['Fluorescence Intensity'])} />
          <DetailsItem title='Pavilion' value={formatPavilion(data['Pavilion'], data['Pavilion Angle'], data['Pavilion Depth'])} />
          <DetailsItem title='Culet Size' value={displayDashIfNotExist(data['Culet Size'])} />
          <DetailsItem title='Inscription' value={displayDashIfNotExist(data['Laser Inscription'])} />
          <DetailsItem title='Separable?' value={formatSeparable(data['Is Matched Pair'], data['Is Matched Pair Separable'])} />
          {data['Fancy Color'] && <DetailsItem title='Colour' value={displayDashIfNotExist(data['Fancy Color Original'])} />}
        </GridItem>
      </Grid>
      <HorizontalRule>Special Notes</HorizontalRule>
      <Spacer xs />
      <Grid>
        <GridItem col='1/2'>
          <DetailsItem title='Report Comments' value={displayDashIfNotExist(data['Cert Comments'])} />
        </GridItem>
        <GridItem col='1/2'>
          <DetailsItem title='Additional Comments' value={displayDashIfNotExist(data['Member Comments'])} />
        </GridItem>
      </Grid>
      <Spacer xs />
    </div>
  )
}

DiamondDetails.propTypes = {
  data: PropTypes.object.isRequired
}

export default DiamondDetails



// WEBPACK FOOTER //
// ./src/components/diamond-details/index.js